import Paginate from "@/components/Paginate";
import SplitViewLayout from "@/components/SplitViewLayout";
import { useHeaderContext } from "@/contexts/HeaderContext";
import CategoryGrid from "@/src/categories/components/CategoryGrid";
import clsx from "clsx";
import pluralize from "pluralize";
import { useEffect } from "react";

const CategoryIndexPage = ({
  pageEntry,
  summary,
  heading,
  pageNumber = 1,
  categories,
  pageCount = 1,
}: {
  pageEntry: {
    uri: string;
    image: {
      url: string;
    }[];
  };
  summary: string;
  heading: string;
  pageNumber: number;
  categories: {
    image?: {
      url: string;
    }[];
    plural?: string;
    title: string;
    heading?: string;
  }[];
  pageCount: number;
}) => {
  // Show the header border for this page
  const { setShowBorder } = useHeaderContext();
  useEffect(() => {
    setShowBorder(true);
    return () => setShowBorder(false);
  }, [setShowBorder]);

  // Use the image from pageEntry, or the last but one image from the categories array
  let images = [];

  if (pageEntry.image.length > 0) {
    images = pageEntry.image;
  } else if (categories.length >= 2) {
    // Get the second to last category that has images
    const categoryWithImages = categories
      .slice()
      .reverse()
      .find((category, index) => index > 0 && category.image?.length > 0);

    images = categoryWithImages?.image || [];
  }

  // TODO: This is a generated summary that we use if the pageEntry doesn't have a summary. This can be removed once we have a summary for every category index page.
  const generatedSummary = `Explore all Mob's ${pluralize(
    heading
  ).toLowerCase()}, from ${(
    categories[0].plural || categories[0].title
  ).toLowerCase()} to ${(
    categories[categories.length - 1].plural ||
    categories[categories.length - 1].heading ||
    categories[categories.length - 1].title
  ).toLowerCase()} and everything in between.`;

  return (
    <div className={clsx("CategoryIndexPage")}>
      <div className={clsx("CategoryIndexPage__header", "border-b")}>
        <SplitViewLayout
          heading={heading}
          introduction={summary || generatedSummary}
          images={images}
        />
      </div>

      <div
        className={clsx(
          "CategoryIndexPage__categoryGrid",
          "px-6 py-6 lg:px-12 lg:py-12"
        )}
      >
        <CategoryGrid categories={categories} />
      </div>
      {pageCount > 1 && (
        <div className={clsx("CategoryIndexPage__paginate", "border-t")}>
          <Paginate
            pageCount={pageCount}
            activePage={pageNumber}
            baseUri={`/${pageEntry.uri}`}
          />
        </div>
      )}
    </div>
  );
};

export default CategoryIndexPage;
